import React, { useState, useEffect, useRef, useMemo } from "react";
import clsx from "clsx";
import { motion } from "framer-motion";
import styles from "./styles.module.scss";
import {
  imgEventIGLive,
  imgEventInterFood,
  imgEventOxonexOpusOne,
  imgEventChefDay,
  imgEventCEOClass,
  imgEventKomakuEverest,
  imgEventSaniaMasterClass,
} from "../../assets/images";
import {
  //  SliderEvent,
  SliderSlickEvent,
} from "../../components";

export default function Events() {
  const refHeading = useRef();
  const refContent = useRef();
  const [elTopHeading, setElTopHeading] = useState(0);
  const [elTopContent, setElTopContent] = useState(0);
  const [showElHeading, setShowElHeading] = useState(false);
  const [showElContent, setShowElContent] = useState(false);
  const [startingPoint, setStartingPoint] = useState(0);

  const variantContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
          staggerChildren: 0.3,
        },
      },
    }),
    []
  );
  const variantContent = useMemo(
    () => ({
      offScreen: { y: 50, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
          staggerChildren: 0.5,
        },
      },
    }),
    []
  );
  const dataEvents = useMemo(
    () => [
      { title: "Instagram Live", img: imgEventIGLive },
      { title: "Interfood 2019", img: imgEventInterFood },
      { title: "Oxone X Opus One", img: imgEventOxonexOpusOne },
      { title: "International Chef Day", img: imgEventChefDay },
      { title: "CEO Class", img: imgEventCEOClass },
      { title: "Komaku Everest Camp", img: imgEventKomakuEverest },
      { title: "Sania Masterclass", img: imgEventSaniaMasterClass },
    ],
    []
  );

  const checkScrollCondition = () => {
    if (
      window.pageYOffset > 0 &&
      elTopHeading > 0 &&
      window.pageYOffset + startingPoint > elTopHeading
    ) {
      setShowElHeading(true);
    } else {
      setShowElHeading(false);
    }
    if (
      window.pageYOffset > 0 &&
      elTopContent > 0 &&
      window.pageYOffset + startingPoint > elTopContent
    ) {
      setShowElContent(true);
    } else {
      setShowElContent(false);
    }
  };

  useEffect(() => {
    const setValues = () => {
      setStartingPoint(window.innerHeight * 0.85);
      if (refHeading.current) setElTopHeading(refHeading.current.offsetTop);
      if (refContent.current) setElTopContent(refContent.current.offsetTop);
    };

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, [refHeading, refContent]);

  useEffect(() => {
    document.addEventListener("scroll", checkScrollCondition, {
      passive: true,
    });

    return () => {
      document.removeEventListener("scroll", checkScrollCondition, {
        passive: true,
      });
    };
  });

  return (
    <div className={clsx("mt-12 py-12 overflow-x-hidden", styles.events)}>
      <motion.div
        ref={refHeading}
        variants={variantContainer}
        initial="offScreen"
        whileInView={showElHeading ? "onScreen" : "offScreen"}
        // viewport={{ once: true }}
        className={clsx("overflow-hidden", styles.container)}
      >
        <motion.h2
          variants={variantContent}
          className="headline-remo text-4xl lg:text-5xl text-center"
        >
          Event
        </motion.h2>
        <motion.p
          variants={variantContent}
          className="mt-4 lg:mt-8 mx-auto w-4/5 lg:w-3/5 lg:text-xl text-center"
        >
          Sebagai bentuk dukungan kami terhadap perkembangan kebutuhan rumah
          tangga, Oxone secara rutin berkolaborasi dengan berbagai pihak.
        </motion.p>
        <motion.div
          ref={refContent}
          initial="offScreen"
          whileInView={showElContent ? "onScreen" : "offScreen"}
          variants={variantContent}
        >
          <SliderSlickEvent
            data={dataEvents}
            classCustom="mt-12"
            showContent={showElContent}
          />
        </motion.div>
        {/* <SliderEvent data={dataEvents} classCustom="mt-12" /> */}
      </motion.div>
    </div>
  );
}
